import { BasketCustomerOrderEntity } from '@genial/services';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { useBatchTicketResumeItem } from '../../../../hooks';

import { TotalSummaryItemDesktop } from './desktop';
import { TotalSummaryItemMobile } from './mobile';
import { TotalSummaryItemTablet } from './tablet';

interface TotalSummaryItemProps {
  item: BasketCustomerOrderEntity;
}

export interface TotalSummaryResponsiveItem extends TotalSummaryItemProps {
  handleDetailsCustomer?: () => void;
  handleRemoveCustomer?: () => void;
  handleExportItem?: () => void;
  handleUpdateBalance?: () => void;
  isLoadingBalance?: boolean;
  detailsBasketItemButtonIsDisabled: boolean;
  availableBalance: number;
  allocatedBalanceField: string;
  remainingBalanceField: string;
}

export const TotalSummaryItem: React.FC<TotalSummaryItemProps> = ({ item }) => {
  const {
    handleRemoveCustomer,
    handleDetailsCustomer,
    handleUpdateBalance,
    isLoadingBalance,
    detailsBasketItemButtonIsDisabled,
    availableBalance,
    allocatedBalanceField,
    remainingBalanceField,
  } = useBatchTicketResumeItem({ item });

  const totalCustomerOffers =
    item?.customerOffers?.reduce((acc, currentItem) => {
      return acc + (currentItem?.basketOffers?.length || 0);
    }, 0) || 0;

  const props = {
    item: { ...item, totalCustomerOffers },
    handleRemoveCustomer,
    handleDetailsCustomer: () => handleDetailsCustomer('totalSummary'),
    handleUpdateBalance,
    isLoadingBalance,
    detailsBasketItemButtonIsDisabled,
    availableBalance,
    allocatedBalanceField,
    remainingBalanceField,
  };

  const layout = useBreakpointValue({
    base: <TotalSummaryItemMobile {...props} />,
    sm: <TotalSummaryItemTablet {...props} />,
    lg: <TotalSummaryItemDesktop {...props} />,
  });

  return layout;
};
